// Sports
import cricketImg from '../assets/images/home/sports/cricket.webp';
import footballImg from '../assets/images/home/sports/football.webp';
import tennisImg from '../assets/images/home/sports/tennis.webp';
import horseRacing from '../assets/images/home/sports/horse_racing.webp';
import greyHound from '../assets/images/home/sports/grey_hound.webp';

// Home Page Mobile banners
import MobCaisnoBanner1 from '../assets/images/banners/casino/mobile_banner2.png';

import SupernovaImg from '../assets/images/casino/providers/supernova.png';
import EvolutionCardImg from '../assets/images/casino/providers/evolution-gaming.webp';
import RoyalCardImg from '../assets/images/casino/providers/royal_gaming.svg';
import SuperSpadeCardImg from '../assets/images/casino/providers/super_spade.png';
import EzugiCardImg from '../assets/images/casino/providers/ezugi.webp';
import sexy from '../assets/images/casino/providers/6.png';
import evoplay from '../assets/images/casino/providers/9.png';
import caleta from '../assets/images/casino/providers/10.png';
import Pragmaticplay from '../assets/images/casino/providers/11.png';
import supernova from '../assets/images/casino/providers/14.png';
import onetouch from '../assets/images/casino/providers/15.png';
import yuvigames from '../assets/images/casino/providers/16.png';
import royalgamevirtual from '../assets/images/casino/providers/17.png';
import pragmaticplay2 from '../assets/images/casino/providers/5.png';
import bigtimegames from '../assets/images/casino/providers/19.png';
import boominggames from '../assets/images/casino/providers/20.png';
import kingmaker from '../assets/images/casino/providers/21.png';
import macvirtual from '../assets/images/casino/providers/23.png';
import monk88 from '../assets/images/casino/providers/24.png';
import fugaso from '../assets/images/casino/providers/25.png';

import SportRadarImg from '../assets/images/casino/providers/sportradar.svg';
import OneTouchImg from '../assets/images/casino/providers/onetouch.svg';
import Spribe from '../assets/images/casino/providers/spribe.webp';
import Mac88 from '../assets/images/casino/providers/mac88.webp';
import FawkImg from '../assets/images/casino/providers/fawak.svg';
import AsiaGaming from '../assets/images/casino/providers/ag.png';
import BetGamesImg from '../assets/images/casino/providers/betgamestv.webp';
import BetSoftImg from '../assets/images/casino/providers/betsoft5.png';
import EaImg from '../assets/images/casino/providers/ea.png';
import GamixImg from '../assets/images/casino/providers/gamzix3.png';
import JiliImg from '../assets/images/casino/providers/Jili.webp';
import KingMakerImg from '../assets/images/casino/providers/kingmakers.png';
import KingMidasImg from '../assets/images/casino/providers/king-midas.png';
import PopOkImg from '../assets/images/casino/providers/popok-gaming.png';
import RedTigerImg from '../assets/images/casino/providers/red-tiger.png';
import Rich88 from '../assets/images/casino/providers/rich88.png';
import RoyalGamingImg from '../assets/images/casino/providers/royal-gaming.webp';
import SmartSoftImg from '../assets/images/casino/providers/smart-soft.webp';
import Playtech from '../assets/images/casino/providers/playtech.webp';
import SportTraderImg from '../assets/images/casino/providers/sportradar.png';

import CricketIcon from '../assets/images/home/tiles/Cricket.svg';
import TennisIcon from '../assets/images/home/tiles/Tennis.svg';
import FootballIcon from '../assets/images/home/tiles/Football.svg';
import TableTennisIcon from '../assets/images/home/tiles/tabletennis-icon.svg';
import EGamesIcon from '../assets/images/home/tiles/egames-icon.svg';
import RugbyIcon from '../assets/images/home/tiles/rugby-icon.svg';
import BoxingIcon from '../assets/images/home/tiles/boxing-icon.svg';
import BasketBallIcon from '../assets/images/home/tiles/basketball-icon.svg';
import BadmintonIcon from '../assets/images/home/tiles/badminton-icon.svg';
import CyclingIcon from '../assets/images/home/tiles/cycling-icon.svg';
import HorseRacingIcon from '../assets/images/home/tiles/horseracing-icon.svg';
import ChessIcon from '../assets/images/home/tiles/chess-icon.svg';
import SnookerIcon from '../assets/images/home/tiles/Snooker.svg';
import DartIcon from '../assets/images/home/tiles/Darts.svg';

// import InplayEventBanner from '../assets/images/sportsbook/banners/inplay-banner.png';
import InplayEventBanner from '../assets/images/sportsbook/banners/inplay.webp';
import CricketEventBanner from '../assets/images/sportsbook/banners/cricket-banner.webp';
import SoccerEventBanner from '../assets/images/sportsbook/banners/soccer-banner.webp';
import TennisEventBanner from '../assets/images/sportsbook/banners/tennis-banner.webp';
import HorseRaceEventBanner from '../assets/images/sportsbook/banners/horse_racing_banner.webp';
import GreyHoundBanner from '../assets/images/sportsbook/banners/greyhound.webp';
import baseballBanner from '../assets/images/sportsbook/banners/baseball.webp';
import basketballBanner from '../assets/images/sportsbook/banners/basketball.webp';

import MobCricketEventBanner from '../assets/images/sportsbook/banners/mob-cricket-banner.webp';
import MobSoccerEventBanner from '../assets/images/sportsbook/banners/mob-soccer-banner.webp';
import MobTennisEventBanner from '../assets/images/sportsbook/banners/mob-tennis-banner.webp';
import MobHorseRaceEventBanner from '../assets/images/sportsbook/banners/mob-horse_racing_banner.webp';
import MobGreyHoundBanner from '../assets/images/sportsbook/banners/mob-greyhound.webp';
import MobBaseballBanner from '../assets/images/sportsbook/banners/mob-baseball.webp';
import MobBasketballBanner from '../assets/images/sportsbook/banners/mob-basketball.webp';

import BinaryEventBanner from '../assets/images/sportsbook/banners/binary-banner.webp';
import IplEventBanner from '../assets/images/sportsbook/banners/ipl-banner.webp';
import { IPL_CUP, WORLD_CUP } from './IPLEvent';
import { CONFIG_PERMISSIONS } from './ConfigPermission';
import { BRAND_NAME } from './Branding';

let HOME_PAGE_WEB_BANNERS = [];

// WEB Carousel Images
if (BRAND_NAME.toLocaleLowerCase() === 'faircric') {
  HOME_PAGE_WEB_BANNERS = [
    {
      image:
        'https://hx-app-assets.s3.eu-west-2.amazonaws.com/kia/faircric-banner1.webp',
      text: 'IPL 2023',
      url: `/exchange_sports/inplay`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
    {
      image:
        'https://hx-app-assets.s3.eu-west-2.amazonaws.com/kia/faircric-banner2.webp',
      text: 'IPL 2023',
      url: `/exchange_sports/cricket/indian-premier-league/indian-premier-league/NDoxMDE0ODA6MjgxMjczNDg=`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
    {
      // image: 'https://hx-app-assets.s3.eu-west-2.amazonaws.com/hypex/banner3.png',
      image:
        'https://hx-app-assets.s3.eu-west-2.amazonaws.com/kia/faircric-banner3.webp',
      text: 'Sports',
      url: '/exchange_sports/cricket/indian-premier-league/indian-premier-league/NDoxMDE0ODA6MjgxMjczNDg=',
      configPermission: CONFIG_PERMISSIONS.sports,
    },
    {
      image:
        'https://hx-app-assets.s3.eu-west-2.amazonaws.com/kia/faircric-banner4.webp',
      text: 'Sports',
      url: '/exchange_sports/cricket',
      configPermission: CONFIG_PERMISSIONS.sports,
    },
    // {
    //   image: 'https://hx-app-assets.s3.eu-west-2.amazonaws.com/kia/faircric-banner5.webp',
    //   text: 'Sports',
    //   url: '/exchange_sports/tennis',
    //   configPermission: CONFIG_PERMISSIONS.sports,
    // },
    // {
    //   image: Banner5, // Virual sports
    //   text: 'Sports',
    //   url: '/exchange_sports/tennis',
    //   configPermission: CONFIG_PERMISSIONS.sports,
    // },
    // {
    //   image: CasinoBanner1,
    //   text: 'Live Casino',
    //   url: '/casino',
    //   configPermission: CONFIG_PERMISSIONS.live_casino,
    // },
  ];
} else {
  HOME_PAGE_WEB_BANNERS = [
    {
      publicUrl:
        'https://hx-app-assets.s3.eu-west-2.amazonaws.com/kia/banner1.png',
      text: 'IPL 2023',
      url: `/exchange_sports/inplay`,
      configPermission: CONFIG_PERMISSIONS.casino,
    },
    {
      publicUrl:
        'https://hx-app-assets.s3.eu-west-2.amazonaws.com/kia/banner2.png',
      text: 'IPL 2023',
      url: `/exchange_sports/cricket/indian-premier-league/indian-premier-league/NDoxMDE0ODA6MjgxMjczNDg=`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
    {
      // publicUrl: 'https://hx-app-assets.s3.eu-west-2.amazonaws.com/hypex/banner3.png',
      publicUrl:
        'https://hx-app-assets.s3.eu-west-2.amazonaws.com/kia/banner3.png',
      text: 'Sports',
      url: '/exchange_sports/cricket/indian-premier-league/indian-premier-league/NDoxMDE0ODA6MjgxMjczNDg=',
      configPermission: CONFIG_PERMISSIONS.sports,
    },
    {
      publicUrl:
        'https://hx-app-assets.s3.eu-west-2.amazonaws.com/kia/banner4.png',
      text: 'Sports',
      url: '/exchange_sports/cricket',
      configPermission: CONFIG_PERMISSIONS.sports,
    },
    // {
    //   image: Banner4,
    //   text: 'Sports',
    //   url: '/exchange_sports/tennis',
    //   configPermission: CONFIG_PERMISSIONS.sports,
    // },
    // {
    //   image: Banner5, // Virual sports
    //   text: 'Sports',
    //   url: '/exchange_sports/tennis',
    //   configPermission: CONFIG_PERMISSIONS.sports,
    // },
    // {
    //   image: CasinoBanner1,
    //   text: 'Live Casino',
    //   url: '/casino',
    //   configPermission: CONFIG_PERMISSIONS.live_casino,
    // },
  ];
}

let HOME_PAGE_MOB_BANNERS = [];
// Mobile Carousel Images
if (BRAND_NAME.toLocaleLowerCase() === 'faircric') {
  HOME_PAGE_MOB_BANNERS = [
    {
      publicUrl:
        'https://hx-app-assets.s3.eu-west-2.amazonaws.com/hypex/faircric-+mob_banner1.webp',
      text: 'IPL 2023',
      url: `/exchange_sports/inplay`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
    {
      publicUrl:
        'https://hx-app-assets.s3.eu-west-2.amazonaws.com/hypex/faircric-+mob_banner2.webp',
      text: 'IPL 2023',
      url: `/exchange_sports/cricket/indian-premier-league/indian-premier-league/NDoxMDE0ODA6MjgxMjczNDg=`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
    {
      publicUrl:
        'https://hx-app-assets.s3.eu-west-2.amazonaws.com/hypex/faircric-+mob_banner3.webp',
      text: 'Sports',
      url: '/exchange_sports/cricket/indian-premier-league/indian-premier-league/NDoxMDE0ODA6MjgxMjczNDg=',
      configPermission: CONFIG_PERMISSIONS.sports,
    },
    {
      publicUrl:
        'https://hx-app-assets.s3.eu-west-2.amazonaws.com/hypex/faircric-+mob_banner4.webp',
      text: 'Sports',
      url: '/home',
      configPermission: CONFIG_PERMISSIONS.sports,
    },
    {
      publicUrl: MobCaisnoBanner1,
      text: 'Live Casino',
      url: '/casino',
      configPermission: CONFIG_PERMISSIONS.live_casino,
    },
  ];
} else {
  HOME_PAGE_MOB_BANNERS = [
    {
      publicUrl: 'https://cdn.hypex.one/hypex/mob_banner1.png',
      text: 'IPL 2023',
      url: `/exchange_sports/inplay`,
      configPermission: CONFIG_PERMISSIONS.casino,
    },
    {
      publicUrl: 'https://cdn.hypex.one/hypex/mob_banner2.png',
      text: 'IPL 2023',
      url: `/exchange_sports/cricket/indian-premier-league/indian-premier-league/NDoxMDE0ODA6MjgxMjczNDg=`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
    {
      publicUrl: 'https://cdn.hypex.one/hypex/mob_banner3.png',
      text: 'Sports',
      url: '/exchange_sports/cricket/indian-premier-league/indian-premier-league/NDoxMDE0ODA6MjgxMjczNDg=',
      configPermission: CONFIG_PERMISSIONS.sports,
    },
    {
      publicUrl: 'https://cdn.hypex.one/hypex/mob_banner4.png',
      text: 'Sports',
      url: '/home',
      configPermission: CONFIG_PERMISSIONS.sports,
    },
    {
      publicUrl: MobCaisnoBanner1,
      text: 'Live Casino',
      url: '/casino',
      configPermission: CONFIG_PERMISSIONS.live_casino,
    },
  ];
}

const HOME_PAGE_HEADERS = {
  liveGames: 'Live Casino',
  sportsBook: 'Sports',
  tvGames: 'TV Games',
  games: 'Games',
  casinoCards: 'Providers',
  royalGamingLive: 'Royal Gaming',
  trendingGames: 'Trending Games',
  royalGamingVirtual: 'Royal Gaming Virtuals',
  payments: 'Payment Methods',
};

const HOME_PAGE_CASINO_TILES = [

  {
    image: EzugiCardImg,
    text: 'Ezugi',
    route: '/casino?provider=Ezugi',
  },
  {
    image: EvolutionCardImg,
    text: 'Playing Cards',
    route: '/casino?provider=Evolution%20Gaming',
  },
  {
    image: Mac88,
    text: 'Mac88 Gaming',
    route: '/casino?provider=Mac88%20Gaming',
  },
  {
    image: RoyalGamingImg,
    text: 'Royal Gaming',
    route: '/casino?provider=Royal%20Gaming',
  },
  {
    image: Spribe,
    text: 'Spribe',
    route: '/casino?provider=SPRIBE',
  },
  {
    image: SmartSoftImg,
    text: 'Smartsoft',
    route: '/casino?provider=Smartsoft%20Gaming',
  },
  {
    image: BetGamesImg,
    text: 'betgames',
    route: '/casino?provider=BetGames',

  },
  {
    image: JiliImg,
    text: 'Jili',
    route: '/casino?provider=JiLi%20Gaming',

  },
  {
    image: Playtech,
    text: 'Playtech',
    route: '/casino?provider=Playtech%20Live',

  },
  {
    image: sexy,
    text: 'sexybcrt',
    route: '/casino?provider=SEXYBCRT',
  },
  {
    image: evoplay,
    text: 'Evoplay',
    route: '/casino?provider=Evoplay%20Entertainment',
  },
  {
    image: caleta,
    text: 'Caleta Gaming',
    route: '/casino?provider=Caleta%20Gaming',
  },
  {
    image: Pragmaticplay,
    text: 'Pragmatic Play',
    route: '/casino?provider=Pragmatic%20Play%20Live',
  },
  {
    image: supernova,
    text: 'Supernova',
    route: '/casino?provider=SuperNowa',
  },
  {
    image: onetouch,
    text: 'Onetouch',
    route: '/casino?provider=OneTouch',
  },
  {
    image: yuvigames,
    text: 'YuviGames',
    route: '/casino?provider=Yuvi%20Games',

  },
  {
    image: royalgamevirtual,
    text: 'Royal Gaming Virtual',
    route: '/casino?provider=Royal%20Gaming%20Virtual',

  },
  {
    image: pragmaticplay2,
    text: 'Pragmatic Play 2',
    route: '/casino?provider=Pragmatic%20Play%202',

  },
   {
    image: bigtimegames,
    text: 'Big Time Games',
    route: '/casino?provider=Big%20Time%20Gaming',
  },
  {
    image: boominggames,
    text: 'Booming Games',
    route: '/casino?provider=Booming%20Games',
  },
  {
    image: kingmaker,
    text: 'KingMaker',
    route: '/casino?provider=KINGMAKER',
  },
  {
    image: macvirtual,
    text: 'Mac88 Virtual',
    route: '/casino?provider=Mac88%20Gaming%20Virtual',
  },
  {
    image: monk88,
    text: 'Monk88',
    route: '/casino?provider=Monk88',
  },
  {
    image: fugaso,
    text: 'Fugaso',
    route: '/casino?provider=Fugaso',
  },
];

const HOME_PAGE_TV_GAMES = [
  {
    image: 'https://cdn.hub88.io/betgamestv/bgt_lucky7.jpg',
    id: '201149:bgt_lucky7:DC:BetGames.TV',
    text: 'Lucky 7',
  },
  {
    image: 'https://cdn.hub88.io/betgamestv/bgt_diceduel.jpg',
    id: '201150:bgt_diceduel:DC:BetGames.TV',
    text: 'Dice Duel',
  },
  {
    image: 'https://cdn.hub88.io/betgamestv/bgt_poker6.jpg',
    id: '201151:bgt_poker6:DC:BetGames.TV',
    text: 'Poker 6+',
  },
  {
    image: 'https://cdn.hub88.io/betgamestv/bgt_warofbets.jpg',
    id: '201152:bgt_warofbets":DC:BetGames.TV',
    text: 'War Of Bets',
  },
  {
    image: 'https://cdn.hub88.io/betgamestv/bgt_wheeloffortune.jpg',
    id: '201153:bgt_wheeloffortune":DC:BetGames.TV',
    text: 'Wheel Of Fortune',
  },
  {
    image: 'https://cdn.hub88.io/betgamestv/bgt_speedy7.jpg',
    id: '201158:bgt_speedy7:DC:BetGames.TV',
    text: 'Speedy 7',
  },
  {
    image:
      'https://cdn.dreamcasino.live/betgamestv/bgt_rockpaperscissors-thumb.jpg',
    id: '201159:bgt_rockpaperscissors:BetGames.TV',
    text: 'Rock Paper Scissors',
  },
  {
    image: 'https://cdn.hub88.io/betgamestv/bgt_bet-on-poker.jpg',
    id: '201157:bgt_bet-on-poker:BetGames.TV',
    text: 'Bet On Poker',
  },
];

const HOME_PAGE_GAMES = [
  {
    image: CricketIcon,
    text: 'Crickets',
    id: 4,
    url: '/exchange_sports/cricket',
  },
  {
    image: TennisIcon,
    text: 'Tennis',
    id: 2,
    url: '/exchange_sports/tennis',
  },
  {
    image: FootballIcon,
    text: 'Football',
    id: 1,
    url: '/exchange_sports/football',
  },
  {
    image: TableTennisIcon,
    text: 'Table Tennis',
    id: 4,
    url: '/home',
  },
  {
    image: EGamesIcon,
    text: 'E Games',
    id: 4,
    url: '/home',
  },
  {
    image: RugbyIcon,
    text: 'Rugby League',
    id: 4,
    url: '/home',
  },
  {
    image: BoxingIcon,
    text: 'Boxing',
    id: 4,
    url: '/home',
  },
  {
    image: BasketBallIcon,
    text: 'Basketball',
    id: 4,
    url: '/home',
  },
  {
    image: BadmintonIcon,
    text: 'Badminton',
    id: 4,
    url: '/home',
  },
  {
    image: CyclingIcon,
    text: 'Cycling',
    id: 4,
    url: '/home',
  },
  {
    image: HorseRacingIcon,
    text: 'Horse Racing',
    id: 4,
    url: '/home',
  },
  {
    image: ChessIcon,
    text: 'Chess',
    id: 4,
    url: '/home',
  },
  {
    image: SnookerIcon,
    text: 'Snooker',
    id: 4,
    url: '/home',
  },
  {
    image: DartIcon,
    text: 'Darts',
    id: 4,
    url: '/home',
  },
];

const HOME_PAGE_IMAGES = {
  poker: {
    image:
      'https://hx-app-assets.s3.eu-west-2.amazonaws.com/gap_casino/lucky7_228001.png',
    id: '100066:ezg_lucky7:EZUGI',
    text: 'Lucky 7',
  },
  blackjack: {
    image: 'https://cdn.hub88.io/evolution/evo_liveblackjackd.jpg',
    id: '200163:evo_speed_blackjack_d:DC:Evolution Gaming',
    text: 'Blackjack D',
  },
  baccarat: {
    image:
      'https://hx-app-assets.s3.eu-west-2.amazonaws.com/gap_casino/no_commission_baccarat_170.png',
    id: '100060:ezg_nocommissionbaccarat:EZUGI:EZUGI',
    text: 'No Comm Baccarat',
    url: '/casino/live-baccarat',
  },
  roulette: {
    image:
      'https://hx-app-assets.s3.eu-west-2.amazonaws.com/gap_casino/ezg_ultimate_roulette1.jpg',
    id: '100082:ezg_ultimate_roulette:EZUGI:Ezugi',
    text: 'Ultimate Roulette',
  },
  vip_roulette: {
    image: 'https://cdn.hub88.io/evolution/evo_liveviproulette.jpg',
    id: '200196:evo_vip_roulette":DC:Evolution Gaming',
    text: 'VIP Roulette',
  },
  dream_catcher: {
    image: 'https://cdn.hub88.io/evolution/evo_livedreamcatcher.jpg',
    id: '200211:evo_dream_catcher":DC:Evolution Gaming',
    text: 'Dream Catcher',
  },
  andarBahar: {
    image:
      'https://hx-app-assets.s3.eu-west-2.amazonaws.com/gap_casino/andar_bahar_228000.png',
    id: '100063:ezg_andarbaharlobby:EZUGI:EZUGI',
    text: 'Andar Bahar',
  },
  teenpatti: {
    image:
      'https://hx-app-assets.s3.eu-west-2.amazonaws.com/gap_casino/teen_patti_227100.png',
    id: '100046:ezg_teenpatti:EZUGI:EZUGI',
    text: 'Teen Patti',
  },

  // SportsSection
  cricket: {
    image: cricketImg,
    text: 'Cricket',
    url: '/exchange_sports/cricket',
  },
  football: {
    image: footballImg,
    text: 'Football',
    url: '/exchange_sports/football',
  },
  tennis: {
    image: tennisImg,
    text: 'Tennis',
    url: '/exchange_sports/tennis',
  },
  greyHound: {
    image: greyHound,
    text: 'greyhound',
    url: '/exchange_sports/greyhound',
  },
  horseRacing: {
    image: horseRacing,
    text: 'horseracing',
    url: '/exchange_sports/horseracing',
  },
};

const EVENT_PAGE_IMAGES = {
  cricket: {
    publicUrl: CricketEventBanner,
    title: 'Cricket',
    url: '/exchange_sports/cricket',
  },
  football: {
    publicUrl: SoccerEventBanner,
    title: 'Football',
    url: '/exchange_sports/football',
  },
  tennis: {
    publicUrl: TennisEventBanner,
    title: 'Tennis',
    url: '/exchange_sports/tennis',
  },

  basketball: {
    publicUrl: basketballBanner,
    title: 'basketball',
    url: '/exchange_sports/basketball',
  },
  baseball: {
    publicUrl: baseballBanner,
    title: 'baseball',
    url: '/exchange_sports/baseball',
  },
  horseracing: {
    publicUrl: HorseRaceEventBanner,
    title: 'HorseRace',
    url: '/exchange_sports/horseracing',
  },
  greyhound: {
    publicUrl: GreyHoundBanner,
    title: 'GreyHound',
    url: '/exchange_sports/greyhound',
  },
  inplay: {
    publicUrl: InplayEventBanner,
    title: 'In Play',
    url: '/exchange_sports/inplay',
  },
  ipl: {
    image: IplEventBanner,
    text: 'WORLD_CUP',
    url: `/exchange_sports/cricket/indian-premier-league/indian-premier-league/${btoa(
      IPL_CUP.routeHash
    )}`,
  },
};

const MOB_EVENT_PAGE_IMAGES = {
  cricket: {
    image: MobCricketEventBanner,
    text: 'Cricket',
    url: '/exchange_sports/cricket',
  },
  football: {
    image: MobSoccerEventBanner,
    text: 'Football',
    url: '/exchange_sports/football',
  },
  tennis: {
    image: MobTennisEventBanner,
    text: 'Tennis',
    url: '/exchange_sports/tennis',
  },

  basketball: {
    image: MobBasketballBanner,
    text: 'Cricket',
    url: '/exchange_sports/basketball',
  },
  baseball: {
    image: MobBaseballBanner,
    text: 'Cricket',
    url: '/exchange_sports/baseball',
  },
  horseracing: {
    image: MobHorseRaceEventBanner,
    text: 'HorseRace',
    url: '/exchange_sports/horseracing',
  },
  greyhound: {
    image: MobGreyHoundBanner,
    text: 'GreyHound',
    url: '/exchange_sports/greyhound',
  },
  inplay: {
    image: InplayEventBanner,
    text: 'In Play',
    url: '/exchange_sports/inplay',
  },
  ipl: {
    image: IplEventBanner,
    text: 'WORLD_CUP',
    url: `/exchange_sports/cricket/indian-premier-league/indian-premier-league/${btoa(
      IPL_CUP.routeHash
    )}`,
  },
};

export default {
  HOME_PAGE_HEADERS,
  HOME_PAGE_IMAGES,
  HOME_PAGE_WEB_BANNERS,
  HOME_PAGE_MOB_BANNERS,
  HOME_PAGE_CASINO_TILES,
  HOME_PAGE_GAMES,
  HOME_PAGE_TV_GAMES,
  EVENT_PAGE_IMAGES,
  MOB_EVENT_PAGE_IMAGES,
};
